// for public jams where you just need to get the user by the email

// pull in config vars
import * as config from "../config"
import fetch from "isomorphic-fetch"

interface User {
	// TODO: What is the shape of the returned JSON?
}

export default async function authAndGetUser(
	JAM_ID: string,
	email: string,
): Promise<User | void> {
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/user`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ email }),
			},
		)

		const json = await res.json()

		window.localStorage.setItem("jamUser", JSON.stringify(json.user))

		return json.user
	} catch (e) {
		console.log(e)
	}
}
